import { render, staticRenderFns } from "./PoyaGroupbuyingOrderList.vue?vue&type=template&id=ca020f62&"
import script from "./PoyaGroupbuyingOrderList.vue?vue&type=script&lang=js&"
export * from "./PoyaGroupbuyingOrderList.vue?vue&type=script&lang=js&"
import style0 from "./PoyaGroupbuyingOrderList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports